import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';

export interface AttributeListConfiguration {
  label?: string;
  note?: string;
  attributes: ModelAttributeConfig[];
}
